import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Contributors
 * id 6D1D5836-B731-41C4-A829-86E5741A0784
 * name microsoft-visual-studio-code
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/microsoft-visual-studio-code.svg
 * tags
 * - Developer / Languages 
 * - Brand / Logo 
 */
export const MicrosoftVisualStudioCodeIcon = createSvgIcon(<><path d="M17,16.47V7.39L11,11.93M2.22,9.19C1.92,8.87 1.91,8.37 2.2,8.04L3.4,6.93C3.6,6.75 4.09,6.67 4.45,6.93L7.87,9.54L15.8,2.29C16.12,1.97 16.67,1.84 17.3,2.17L21.3,4.08C21.66,4.29 22,4.62 22,5.23V18.73C22,19.13 21.71,19.56 21.4,19.73L17,21.83C16.68,21.96 16.08,21.84 15.87,21.63L7.85,14.33L4.45,16.93C4.07,17.19 3.6,17.12 3.4,16.93L2.2,15.83C1.88,15.5 1.92,14.96 2.25,14.63L5.25,11.93" /></>, 'MicrosoftVisualStudioCodeIcon');
export default MicrosoftVisualStudioCodeIcon